import { defineStore } from 'pinia'

const useRoleStore = defineStore('role', {
  state: () => ({ ability: [] }),
  getters: {
    canUserCreateTicket(state) {
      const res = state.ability.findIndex(item => item.subject === 'create-ticket')
      // console.log('canUserCreateTicket', res)
      return res !== -1
    },
    canUserChangeAssignee(state) {
      const res = state.ability.findIndex(item => item.subject === 'change-assignee')
      // console.log('canUserChangeAssignee', res)
      return res !== -1
    },
    canUserDeleteAssignee(state) {
      const res = state.ability.findIndex(item => item.subject === 'delete-ticket')
      // console.log('canUserDeleteAssignee', res)
      return res !== -1
    },
    canUserViewTicket(state) {
      const res = state.ability.findIndex(item => item.subject === 'view-ticket')
      return res !== -1
    },
  },
  actions: {
    setAbility(ability) {
      this.ability = ability
    },
  },
})

export default useRoleStore
